import React from 'react';
import ReactDOM from 'react-dom';
import './assets/css/main.css';
import './assets/css/new.css';
import App from './App';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
